import { axiosBackendInstance } from '../axiosInstance'

export const changeOnboardingStep = async (data) => {
  return axiosBackendInstance.post('/api/v1/onboarding/', data)
}

export const interruptOnboarding = async () => {
  return axiosBackendInstance.put('/api/v1/onboarding/interrupt/')
}
